/*

 _      _       _    _                _
| |    (_)     | |  | |              | |
| |     _ _ __ | | _| |     ___   ___| | _____ _ __
| |    | | '_ \| |/ | |    / _ \ / __| |/ / _ | '__|
| |____| | | | |   <| |___| (_) | (__|   |  __| |
|______|_|_| |_|_|\_|______\___/ \___|_|\_\___|_|

=======================*============================

utilities.js - Various shared utility functions


*/

// set a version number for the service worker,
// built from CSS and JS hashes
const swVersion = () => {
  let scriptTag = document.getElementsByTagName('script')[0];
  let scriptParam = scriptTag.src.split('%3Fq%3D')[1];
  let stylesTag = document.querySelector('[rel="stylesheet"]');
  let stylesParam = stylesTag.href.split('%3Fq%3D')[1];

  return scriptParam + stylesParam;
};

// encode HTML characters
const htmlEncode = (r) => {
  return r.replace(/[\x26\x0A\<>'"]/g, function (r) {
    return '&#' + r.charCodeAt(0) + ';';
  });
};

// Call this in devtools, and then each focused element will
// be logged to the console; use for a11y testing or debugging
const focusLogger = () => {
  document.addEventListener(
    'focusin',
    () => {
      console.log('focused: ', document.activeElement);
    },
    true
  );
};

// True if a link editor is open, false if not
const linkEditorIsLive = () => {
  return document.querySelector('.link-li #editForm') === null ? false : true;
};
